import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addMerchantAPI, merchantDetailAPI, merchantListAPI, updateMerchantDetailAPI
} from '../api-requests/merchant';
import {
    addMerchantRequestError, addMerchantRequestSuccess, merchantDetailRequestError,
    merchantDetailRequestSuccess, merchantListRequestError, merchantListRequestSuccess,
    updateMerchantDetailsRequestError, updateMerchantDetailsRequestSuccess
} from './merchant.action';
import { MerchantActionTypes } from './merchant.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';
import { APP_CONSTANTS } from '../../utils/AppConstants';

function* handleUpdateMerchantDetailRequest({ payload }) {
    try {
        const response = yield call(updateMerchantDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateMerchantDetailsRequestSuccess(decryptedData))
            } else {
                yield put(updateMerchantDetailsRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: MerchantActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(updateMerchantDetailsRequestError(error.response.data))
        }
    }
}

export function* updateMerchantDetailReq() {
    yield takeLatest(MerchantActionTypes.UPDATE_MERCHANT_DETAIL_REQUEST, handleUpdateMerchantDetailRequest)
}

function* handleMerchantListRequest({ payload }) {
    try {
        const response = yield call(merchantListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(merchantListRequestSuccess(decryptedData))
            } else {
                yield put(merchantListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: MerchantActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(merchantListRequestError(error.response.data))
        }
    }
}

export function* merchantListReq() {
    yield takeLatest(MerchantActionTypes.MERCHANT_LIST_REQUEST, handleMerchantListRequest)
}

function* handleMerchantDetailRequest({ payload }) {
    try {
        const response = yield call(merchantDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(merchantDetailRequestSuccess(decryptedData))
            } else {
                yield put(merchantDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: MerchantActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(merchantDetailRequestError(error.response.data))
        }
    }
}

export function* merchantDetailReq() {
    yield takeLatest(MerchantActionTypes.MERCHANT_DETAIL_REQUEST, handleMerchantDetailRequest)
}

function* handleAddMerchantRequest({ payload }) {
    try {
        const response = yield call(addMerchantAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addMerchantRequestSuccess(decryptedData))
            } else {
                yield put(addMerchantRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        if (error.response?.status === 401) {
            const errData = {
                status: error.response?.status,
                isSessionError: true,
                message: APP_CONSTANTS.SESSION_EXPIRE_MESSAGE
            }
            yield put({ type: MerchantActionTypes.COMMON_ERROR, errData })
        } else {
            displayConsoleLog(error.response?.data)
            yield put(addMerchantRequestError(error.response.data))
        }
    }
}

export function* addMerchantReq() {
    yield takeLatest(MerchantActionTypes.ADD_MERCHANT_REQUEST, handleAddMerchantRequest)
}